module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"update_review":"리뷰 수정하기"}}')
  delete Component.options._Ctor
}
